/** @format */
import { initPData } from '@/utils/p-data';

export * from '@/p-components';
export * from '@/components';
export * from '@/p-layout';
export * from '@/layout';
export * from '@/store';
export * from '@/store/modules';

export * from '@/router/index-lib-main';
export * from '@/api';
export * from '@/utils';

initPData();

// export * from '@/types';
